const ROUTE_PATHS = {
    MAIN: '/',
    LOGIN: '/login',
    IN_SESSION: '/insession',
};

export default ROUTE_PATHS;
